import { ProductDetailsDtoResponse } from './product-details.dto-response';

export class ProductDetailsModel {
  product: ProductDetailsDtoResponse;
  qty: number;
  id: string;
}
